import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const ExclusionRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const ExclusionDescription = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 13px;
	line-height: 1.5;
`;

export const ExclusionForm = styled.form`
	display: flex;
	align-items: flex-end;
	gap: 12px;
	flex-wrap: wrap;
`;

export const FieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	flex: 1;
	min-width: 160px;
`;

export const FieldLabel = styled.label`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
`;

export const NumberInput = styled.input`
	height: 44px;
	padding: 0 14px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	width: 100%;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

export const ExcludedNotice = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 14px 16px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.borderActive};
	background: rgba(3, 98, 212, 0.1);
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 13px;
	font-weight: 500;
	line-height: 1.4;
`;

export const ExcludedInfo = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	line-height: 1.4;
`;
